import React, {useEffect, useState} from "react";
import {
    createMuiTheme,
    ThemeProvider,
    responsiveFontSizes,
} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Link} from "@reach/router";
import AllData from "./AllData";
import DataChart from "./Chart";

let theme = createMuiTheme({
    palette: {
        background: {
            paper: "#101010",
        },
        type: "dark",
    },
});
theme = responsiveFontSizes(theme);

const Country = ({name}) => {
    const [dataAxes, setDataAxes] = useState([]);
    const [dataCases, setDataCases] = useState([]);
    const [dataDeaths, setDataDeaths] = useState([]);
    const [dataRedcovered, setDataRecovered] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async (url) => {
            setIsError(false);
            setIsLoading(true);

            try {
                const result = await fetch(url);
                const data = await result.json();
                setDataAxes(Object.keys(data.timeline.cases));
                setDataCases(Object.values(data.timeline.cases));
                setDataDeaths(Object.values(data.timeline.deaths));
                setDataRecovered(Object.values(data.timeline.recovered));
            } catch (error) {
                setIsError(true);
            }

            setIsLoading(false);
        };
        fetchData(`https://disease.sh/v3/covid-19/historical/${name}?lastdays=all`);
    }, [name]);

    return (
        <ThemeProvider theme={theme}>
            <Box component="section" m={2}>
                <Grid container direction="column">
                    <Grid item>
                        <header>
                            <Typography
                                style={{color: "#fff", marginBottom: "16px"}}
                                variant="h4"
                            >
                                <Link
                                    style={{
                                        textDecoration: "none",
                                        userSelect: "none",
                                    }}
                                    to="/"
                                >
                                    COVID-19 DASHBOARD
                                </Link>
                                {` - ${name}`}
                            </Typography>
                        </header>
                    </Grid>
                    <Grid item xs={12}>
                        <AllData
                            url={`https://disease.sh/v3/covid-19/countries/${name}`}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Paper style={{padding: "10px", marginTop: "32px"}}>
                            <Typography variant="subtitle1">
                                For best experience with chart on mobile, use
                                landscape mode and refresh.
                            </Typography>
                        </Paper>
                        <Paper style={{padding: "10px", marginTop: "16px"}}>
                            <Typography variant="subtitle1">
                                You can click on the Cases, Deaths, and
                                Recovered to select ( or deselect) lines on
                                graph
                            </Typography>
                        </Paper>

                        <Paper
                            style={{
                                padding: "10px",
                                marginTop: "16px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "flex-start",
                            }}
                        >
                            {isLoading && <CircularProgress />}
                            {!isLoading && (
                                <DataChart
                                    error={isError}
                                    axes={dataAxes}
                                    dataCases={dataCases}
                                    dataDeaths={dataDeaths}
                                    dataRecovered={dataRedcovered}
                                />
                            )}
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </ThemeProvider>
    );
};

export default Country;
